import { render, staticRenderFns } from "./mpBox.vue?vue&type=template&id=432c015d"
import script from "./mpBox.vue?vue&type=script&lang=js"
export * from "./mpBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports